var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c(_vm.iconComponent,{tag:"component",class:_vm.iconClass,attrs:{"color":_vm.color}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }